module.exports = __webpack_public_path__ + "assets/img/Type E (46).f3b5f357.jpg";